import React from "react";
import { BillingSection } from "../Billing";
import { BillingLineItem } from "./types";
import { CreatePageBlock } from "./CreatePageBlock";

const billingLabel = { text: "Total monthly cost" };

type Props = {
  /**
   * A list of billing line items to display to the user. Forwarded to the billing component.
   */
  items: BillingLineItem[];

  primaryUnit?: "monthly" | "hourly";
};

export const CreatePageBilling: React.FC<Props> = (props) => {
  const { items, primaryUnit = "monthly" } = props;

  return (
    <CreatePageBlock label={billingLabel}>
      <BillingSection primaryUnit={primaryUnit} items={items} />
    </CreatePageBlock>
  );
};

CreatePageBilling.displayName = "CreatePageBilling";
